import React from "react";
import { Button, Modal, Image } from "react-bootstrap";
import Carousel from 'react-bootstrap/Carousel';
import './ModalContaint.css';


export const PreviewModal = (props) => {
    return (
        <>
            <Modal {...props} backdrop="static" id="preview-modal" dialogClassName="modal-md modal-box" keyboard={false}>
                <Modal.Header
                    closeButton
                    className="modal-header border-0"
                >
                    <h4 className='previewTemplate'> {' '+(props.selectedTemplate && props.selectedTemplate.product.templateVariant)}<br/><br/>Version</h4>
                </Modal.Header>
                <Modal.Body>
										{props.previewImage && (
											<Image
												src={
													process.env.REACT_APP_JOSTENS_CDN_HOST + props.previewImage
												}
												alt='stole-preview'
												className='preview-image'
											/>
										)}
                </Modal.Body>
            </Modal>
        </>
    );
};
